"use strict";

import React from "react";
import FaFacebook from "react-icons/lib/fa/facebook";
import ContactForm from "./ContactForm.js";
import Menu from "./Menu.js";

class TopBar extends React.Component {
  render() {
    return (
      <div className="topbar-component" id="topbar">
        <div className="topbar-content">
          <div className="row">
            <a href="#inicio">
              <img className="topbar-logo" src="/static/images/nhpd.svg" />
            </a>
            <Menu />
            <p className="schedule">
              Horário: 2ª a 6ª das 8h30 às 18h e Sábado das 9h às 12h30
            </p>
          </div>
          <div className="contacts">
            <div className="social-media-links">
              <a
                href="https://facebook.com/NHPremiumDetails"
                target="_blank"
                className="social-media-link"
              >
                <FaFacebook />
              </a>
            </div>
            <ContactForm />
            {/* <button>Contacte-nos</button> */}
          </div>
        </div>
      </div>
    );
  }
}

TopBar.displayName = "topbar";

// Uncomment properties you need
// Footer.propTypes = {};
// Footer.defaultProps = {};

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/TopBar.js